import repository from '@/repositories/repository'

export default baseUrl => {
    const headers = {responseType: "arraybuffer"}

    return {
        relatorioEnvio(params) {
            return repository.post(`${baseUrl}/bnafar-relatorio-envio`, params, headers)
        },
    }
}